import {
  COLLABORATION_INIT_WITH_STATE_PROXY,
  COLLABORATION_ENTER_ROOM,
  COLLABORATION_LEAVE_ROOM,
  COLLABORATION_CLOSE_ALL_ROOMS,
  COLLABORATION_LOCAL_DOCUMENT_UPDATE,
  COLLABORATION_REFRESH_ROOM,
  COLLABORATION_SUBMISSION,
  COLLABORATION_SUBMISSION_LOCK,
  COLLABORATION_SUBMISSION_UNLOCK,
  COLLABORATION_REFETCH_ROOM,
} from 'common/types';

export default {
  initWithStateProxy: (initState) => ({
    type: COLLABORATION_INIT_WITH_STATE_PROXY,
    initState,
  }),
  // {roomName, storePath, initState?}
  enterRoom: (options) => ({
    ...options,
    type: COLLABORATION_ENTER_ROOM,
  }),
  localUpdated: (options) => ({
    ...options,
    type: COLLABORATION_LOCAL_DOCUMENT_UPDATE,
  }),
  leaveRoom: (options) => ({
    ...options,
    type: COLLABORATION_LEAVE_ROOM,
  }),
  closeAllRooms: (options) => ({
    ...options,
    type: COLLABORATION_CLOSE_ALL_ROOMS,
  }),
  // call this when you want to share that
  // the whole room should reconnect.
  refreshRoom: (options) => ({
    ...options,
    type: COLLABORATION_REFRESH_ROOM,
  }),
  refetchRoom: (options) => ({
    ...options,
    type: COLLABORATION_REFETCH_ROOM,
  }),
  submission: ({grantId, subGrantId, who, entityId, entityType}) => ({
    type: COLLABORATION_SUBMISSION,
    grantId,
    subGrantId,
    who,
    entityId,
    entityType,
  }),
  submissionLock: ({who, entityId, entityType, grantId, subGrantId}) => ({
    type: COLLABORATION_SUBMISSION_LOCK,
    who,
    entityId,
    entityType,
    grantId,
    subGrantId,
  }),
  submissionUnlock: ({entityId}) => ({
    type: COLLABORATION_SUBMISSION_UNLOCK,
    entityId,
  }),
};
